import { Paper, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'

export default function ConsistencyCheck({ rows }) {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Konzistenčný check</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Currency</TableCell>
              <TableCell align="right">current_budget (fondy + wallets)</TableCell>
              <TableCell align="right">total_income (allocations)</TableCell>
              <TableCell align="right">delta_should_be_zero</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(!rows || rows.length === 0) && (
              <TableRow><TableCell colSpan={4}>Žiadne dáta</TableCell></TableRow>
            )}
            {rows?.map((r, i) => (
              <TableRow key={`${r.currency}-${i}`}>
                <TableCell>{r.currency}</TableCell>
                <TableCell align="right">{Number(r.current_budget).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align="right">{Number(r.total_income).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align="right">{Number(r.delta_should_be_zero).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
